import type { AppModule } from './types'
import { createHead } from '@unhead/vue/client'

import { ApolloClients } from '@vue/apollo-composable'
import { createApp, h, provide } from 'vue'
import App from '@/App.vue'

import { clients } from '@/graphql'
import 'swagger-ui/dist/swagger-ui.css'
import 'v-calendar/dist/style.css'

import '@/assets/style/index.css'

const head = createHead()

export const app = createApp({
  setup() {
    provide(ApolloClients, clients)
  },
  render: () => h(App),
})

// app.config.errorHandler = (err, instance, info) => {
//   // report error to tracking services
//   console.error(err, instance, info)
// }

// install all modules under `modules/`
Object.values(import.meta.glob<{ default: AppModule }>('./modules/*.ts', { eager: true })).forEach(
  (module) => {
    if (module?.default) {
      app.use(module?.default)
    }
  },
)

app.use(head)
app.mount('#app')
